import type { Lootbox } from '@/api/common';
import { isWheelLootbox } from '@/helpers/realTimeService';
import { isDiceLootbox } from './diceRoll';
import { isScratchLootbox } from './scratchGame';

enum LootboxTag {
  WHEEL = 'wheel',
  SCRATCH_GAME = 'scratch_game',
  DICE_ROLL = 'dice_roll',
}

const isWithoutTagLootbox = (lootbox: Lootbox) =>
  !(
    isWheelLootbox(lootbox) ||
    isScratchLootbox(lootbox) ||
    isDiceLootbox(lootbox)
  );

const tagLootboxMap = {
  [LootboxTag.WHEEL]: isWheelLootbox,
  [LootboxTag.SCRATCH_GAME]: isScratchLootbox,
  [LootboxTag.DICE_ROLL]: isDiceLootbox,
};

const filterLootboxesByTag =
  (tag: LootboxTag | null) => (lootboxes?: Lootbox[]) => {
    if (!lootboxes) return [];

    return lootboxes.filter((lootbox) =>
      tag ? tagLootboxMap[tag](lootbox) : isWithoutTagLootbox(lootbox)
    );
  };
export const findWheelLootboxes = filterLootboxesByTag(LootboxTag.WHEEL);
export const findScratchLootboxes = filterLootboxesByTag(
  LootboxTag.SCRATCH_GAME
);
export const findDiceLootboxes = filterLootboxesByTag(LootboxTag.DICE_ROLL);
export const findLootboxesWithoutTags = filterLootboxesByTag(null);
